import classNames from 'classnames';
import type { ScheduleDayModel } from 'entities/campaign';
import { Checkbox } from 'shared/ui/Checkbox';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { addSpaceToSchedule } from 'shared/lib/time-ranges';

export function SchedulingDay({
  name,
  period,
  className,
  index,
}: {
  index: number;
  name: string;
  period: ScheduleDayModel;
  className?: string;
}) {
  const shortName = name.slice(0, 3);

  return (
    <div
      data-testid={`schedulingDay-${shortName}`}
      className={classNames('flex justify-between', className)}
    >
      <Checkbox
        name={`${name}.isSelected`}
        isDisabled
        {...getDataAutoTestAttributes([`checkbox-scheduling-day-${index + 1}`])}
      >
        <span className="text-sm">{shortName}</span>
      </Checkbox>
      <div
        className="flex w-40 justify-between text-sm font-medium text-slate-400"
        {...getDataAutoTestAttributes([`time-scheduling-day-${index + 1}`]).attributes}
      >
        <p>{addSpaceToSchedule(period.timeFrom)}</p>
        <p>-</p>
        <p>{addSpaceToSchedule(period.timeTo)}</p>
      </div>
    </div>
  );
}
